const medias = {
  phone: 'screen and (max-width: 767px)',
  mobile: 'screen and (max-width: 991px)',
  desktop: 'screen and (min-width: 992px)',
};

export { medias };
